import type { FC } from "react";
import React from "react";

import { Badge } from "../../../../Badge/Badge";

import type {
    BadgeProps,
    IconBadgeProps,
    IEmojiBadgeProps,
    IImageBadgeProps,
} from "../../../../Badge/Badge";

const AVATAR_BADGE_TEST_ID = "avatar-badge-test-id";

type AbsentedProps = "size" | "stroke";

type AvatarBadgeProps =
    | Omit<IconBadgeProps, AbsentedProps>
    | Omit<IImageBadgeProps, AbsentedProps>
    | Omit<IEmojiBadgeProps, AbsentedProps>;

export const AvatarBadge: FC<AvatarBadgeProps> = (props) => {
    return (
        <Badge
            {...(props as BadgeProps)}
            stroke
            data-tsid={AVATAR_BADGE_TEST_ID}
        />
    );
};

AvatarBadge.displayName = "Avatar.Badge";

export default AvatarBadge;
